<template>
    <div id="welcome-wrapper" v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }">
        <div class="row">
            <div class="col-1">
                <img class="img-fluid" src="@/assets/welcome-1.svg">
            </div>
            <div class="col-10 text-center pb-3 pt-3" style="align-self: flex-end;">
                <h1 class="lato-light">Welcome</h1>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-8 col-10 offset-sm-2 offset-1 text-center">
                <p class="lato-light">
                    If you want to generate passive income while you’re off doing what you love,
                    then <b>Bitcoin.com Games Affiliates</b> is just the place for you!
                    Start earning within minutes of signing up.
                    Expect a generous share of the revenue generated by your network of players.
                    <b>Just refer to start earning!</b>
                </p>
                <p class="lato-light">
                    <b>Bitcoin.com Games</b> is a <b>provably fair Casino</b> where players can enjoy games
                    from top providers in the industry as well as exclusively developed in-house
                    games.
                    Benefit from our massive base of loyal users - CTR conversion from  50-60%

                </p>
            </div>
        </div>
        <div class="row" id="welcome-bottom-icon">
            <div class="col-1 offset-11">
                <img class="img-fluid" src="@/assets/welcome-2.svg">
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "Welcome",
        computed: mapGetters([
            'intersectionOptions'
        ]),
        methods: {
            ...mapActions([
                'setActiveTab',
            ]),
            onWaypoint({ going }) {
                if(going === 'in') {
                    this.setActiveTab('welcome-wrapper');
                }
            }
        }
    }
</script>

<style scoped>
    #welcome-wrapper {
        background-color: #FFFFFF;
    }

    h1 {
        font-size: calc(2.5rem + 5vmin);
    }

    p {
        text-align: justify;
        font-size: calc(0.4rem + 2vmin);
    }

    @media (max-width: 576px) {
        #welcome-bottom-icon {
            display: none;
        }

        h1 {
            font-size: calc(1.5rem + 6vmin);
            padding-top: 2rem;
        }

        p {
            text-align: justify;
            font-size: calc(0.5rem + 2.7vmin);
            padding-bottom: 2rem;
        }
    }
</style>
